<ng-container *ngIf="userData.accountMenuEnabled; else simplePopoverTpl">
  <shrd-pf-ft-header-user-account-wrapper
    class="left-panel"
    [userAccount]="userData.selectedAccount"
    [omitUserTitle]="true"
    [canSwitchAccount]="userData.accounts?.length > 1"
    [logoutConfig]="logoutConfig"
    (toggleAccountSelection)="toggleAccountSelection($event)"
  ></shrd-pf-ft-header-user-account-wrapper>
  <div
    class="right-panel"
    [ngClass]="{ 'is-content-loading': !accountLinks }"
    *shrdUtcLet="accountLinks$ | async as accountLinks"
  >
    <div
      #rightPanelContent
      class="right-panel-content"
      shrdUicScrollbar
      [scrollBarVerticalRef]="scrollbar"
      [scrollContentRef]="scrollContent"
    >
      <div #scrollContent class="scroll-content">
        <shrd-pf-ui-content-slider [slideOn]="showAccountSelection" class="min-h-100">
          <shrd-pf-ui-header-user-select
            class="account-selection-view secondary"
            [accounts]="userData.accounts"
            [selectedAccountId]="userData.selectedAccount.originId"
            [disabled]="!showAccountSelection"
            (accountChanged)="onAccountChanged($event)"
          ></shrd-pf-ui-header-user-select>
          <div class="account-links-view primary bg-light">
            <shrd-pf-ui-links-column-wrapper
              class="link-column"
              *ngFor="let linkSection of accountLinks"
              [sectionTitle]="linkSection.title"
              [links]="linkSection.links"
              [disabled]="showAccountSelection"
            ></shrd-pf-ui-links-column-wrapper>
            <shrd-uic-preloader immediate [active]="!accountLinks"></shrd-uic-preloader>
          </div>
        </shrd-pf-ui-content-slider>
      </div>
    </div>
    <shrd-uic-scrollbar #scrollbar></shrd-uic-scrollbar>
  </div>
</ng-container>

<ng-template #simplePopoverTpl>
  <div class="px-3 py-1 w-100">
    <shrd-pf-ft-header-registration-button [userData]="userData" />
    <shrd-pf-ft-header-user-logout buttonClasses="m-0" buttonVariant="tertiaryFlyout" [logoutConfig]="logoutConfig">
      <span>{{ 'header.account.logout' | i18next }}</span>
    </shrd-pf-ft-header-user-logout>
  </div>
</ng-template>
